// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"tableWrapper--1KOq0","storesButton":"storesButton--3Yv98","dateWrapper":"dateWrapper--2ZZby"};